import React from 'react';

import { ReactComponent as IndicatorIcon } from '@assets/svg/sensors-temperature/indicator.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const DowntimeIndicators = () => {
  const { t } = useTranslation();

  const rows = [
    ['D131', 'D132', 'D133', 'D134', 'D135', 'D136'],
    ['D121', 'D122', 'D123', 'D124', 'D125', 'D126'],
    ['D111', 'D112', 'D113', 'D114', 'D115', 'D116'],
    ['D117', 'D118', 'D119', 'D110'],
    ['D105', 'D106'],
  ];

  return (
    <div className={style.downtimeIndicatorsContainer}>
      <span className={style.downtimeIndicatorsTitle}>{t('Downtime Indicator')}</span>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className={style.indicatorsContainer}>
          {row.map((item) => (
            <div key={item} className={style.indicator}>
              <span>{item}</span>
              <IndicatorIcon className={style.indicatorIcon} />
            </div>
          ))}
        </div>
      ))}
      <span className={style.diagnosticPointsText}>Diagnostic Points</span>
    </div>
  );
};

export default DowntimeIndicators;
